@if (isMenu) {
  <button mat-menu-item aria-label="Tags">
    <div class="item-menu-center">
      <span class="material-symbols-outlined">label</span>
      <span>{{ (label ? label : 'tags') | translate }}</span>
    </div>
  </button>
} @else {
  <button
    mat-icon-button
    [attr.aria-label]="(label ? label : 'tags') | translate"
    matTooltip="{{ (label ? label : 'tags') | translate }}">
    <span class="material-symbols-outlined">label</span>
  </button>
}
